export function getBackUrl(customerAdminUrl: string, cherreAdminUrl: string) {
  const isCustomerAdmin = window.location?.pathname?.includes('customerAdmin');
  return isCustomerAdmin ? customerAdminUrl : cherreAdminUrl;
}
